import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _machineUrls, _PacsEditTagsUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, MachineProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const editMachineApi = {
    editMachineApi: createAsyncThunk(
        "machine/edit",
        async (props: MachineProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _machineUrls.edit(props.deviceName),
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                        body: JSON.stringify(props.savedInformation),
                    }
                );
                if (!response.ok) {
                    throw new Error('Failed to update patient tags');
                }

                if (response.status === 204) {
                    return { status: 204, ok: true, message: "Machine updated successfully." };
                }

                const data: ApiResponse<any> = await response.json();
                return data;

            } catch (error) {
                return rejectWithValue(error);
            }
        }
    ),
};
